import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { ScrollArea as a } from "@base-ui/react/scroll-area";
import { cn as e } from "../../lib/utils.js";
function u({
  className: o,
  children: l,
  ...t
}) {
  return /* @__PURE__ */ i(
    a.Root,
    {
      "data-slot": "scroll-area",
      className: e("relative", o),
      ...t,
      children: [
        /* @__PURE__ */ r(
          a.Viewport,
          {
            "data-slot": "scroll-area-viewport",
            className: "size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1",
            children: l
          }
        ),
        /* @__PURE__ */ r(n, {}),
        /* @__PURE__ */ r(a.Corner, {})
      ]
    }
  );
}
function n({
  className: o,
  orientation: l = "vertical",
  ...t
}) {
  return /* @__PURE__ */ r(
    a.Scrollbar,
    {
      "data-slot": "scroll-area-scrollbar",
      "data-orientation": l,
      orientation: l,
      className: e(
        "flex touch-none p-px transition-colors select-none data-horizontal:h-2.5 data-horizontal:flex-col data-horizontal:border-t data-horizontal:border-t-transparent data-vertical:h-full data-vertical:w-2.5 data-vertical:border-l data-vertical:border-l-transparent",
        o
      ),
      ...t,
      children: /* @__PURE__ */ r(
        a.Thumb,
        {
          "data-slot": "scroll-area-thumb",
          className: "relative flex-1 rounded-full bg-border"
        }
      )
    }
  );
}
export {
  u as ScrollArea,
  n as ScrollBar
};
//# sourceMappingURL=scroll-area.js.map
